import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
export default class GetUserProfileNotificationsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.repository
   */
  constructor({repository}) {
    super()

    this._repository = repository
  }

  /**
   * @return userProfileNotifications.isPortalAnnoucementsShowed cookie value
   */
  execute = async () => {
    const portalAnnoucements = await this._repository.getPortalAnnoucementsShowed()
    return portalAnnoucements.toJSON()
  }
}
